import { AxiosResponse } from 'axios'
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from '../BaseRepository'

export default class AvailableBlocksRepository extends BaseRepository {
  constructor (protected endpoint: string, axios: NuxtAxiosInstance) {
    super(endpoint, axios)
  }

  public getAvailableBlocks (pageAlias: string = ''): Promise<AxiosResponse> {
    return this.$axios.get(`${this.endpoint}/${pageAlias}`)
  }
}
